import React from "react";
import Navbar from "../components/main_page/Navbar";
import AboutMe from "../components/main_page/AboutMe";
import Portfolio from "../components/main_page/Portfolio";
import name from "../assets/icons/name.svg";
import Contact from "../components/main_page/Contact";
import cover from "../assets/images/cover_pic-min.webp";

function Home() {
  return (
    <div className="pb-96 z-0">
      <Navbar focus="home" />
      <div className="mt-80 relative w-90vw md:mt-20 mb-80">
        <div className="w-[80vw] h-[50vh] bg-cool-200 mt-44 md:ml-28 shadow-3xl md:w-[60vw] md:h-[60vh]">
          <div>
            <img
              src={name}
              alt="name"
              className="absolute w-[90vw] mt-[-370px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 md:left-0 md:transform-none md:mt-0 md:relative md:ml-[43vw] md:pt-10 object-scale-down md:w-[40vw]"
            />
          </div>

          <div className="flex flex-col items-center bg-cool-300 p-6 text-white w-[70vw] min-h-[33vh] absolute top-[50vh] left-1/2 transform -translate-x-1/2 -translate-y-1/2 md:transform-none md:top-[10vh] md:left-0 md:w-[30vw] md:mt-[100px] md:min-h-[55vh] md:ml-[54vw]">
            <p className="font-monts xmd:text-3xl md:text-lg mt-5">
              <span className="font-bold block mb-8">Hi, I’m Eddie</span>{" "}
              <span className="font-light">
                I use my passion for learning new technologies to make software
                solutions that enhance human connection!
              </span>
            </p>
            <div className=" bg-white h-[1px] w-[90%] mt-10 p-0 "></div>
          </div>
        </div>
        <img
          src={cover}
          alt="My image"
          className="rounded-md ml-10 mt-[-90px] absolute top-[0] w-[60vw] h-[42vh] object-cover md:mt-[-30px] md:ml-40 md:w-[25vw] md:h-[70vh] "
        />
      </div>

      <AboutMe />
      <Portfolio />
      <Contact />
    </div>
  );
}

export default Home;
